import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ELanguage } from 'src/models/common.model';
import { MoneyAndTransactionsRoute } from 'src/models/routes.model';
import { ETransactionUiType, ITransaction } from 'src/models/transactions.model';

@Component({
  selector: 'liberro-transaction-item',
  standalone: false,
  templateUrl: './liberro-transaction-item.component.html',
  styleUrl: './liberro-transaction-item.component.less'
})
export class LiberroTransactionItemComponent {
  public readonly moneyAndTransactionsRoute = MoneyAndTransactionsRoute;

  @Input({ required: true }) public transaction!: ITransaction;
  @Input({ required: true }) public type?: 'detailed' | 'investment-detail';
  /** When true, the right arrow opens transaction detail (via optionSelected); the row uses routerLink to the same detail when applicable. */
  @Input() public detailedOpensTransactionDetail = false;
  @Input() public localization: ELanguage = ELanguage['cs-CZ'];
  @Output() public optionSelected = new EventEmitter<string>();

  public get transactionValueSign(): string {
    let sign = '';
    switch (this.transaction.uiType) {
      case ETransactionUiType.WITHDRAWAL:
      case ETransactionUiType.FEE:
        sign = '-';
        break;
      case ETransactionUiType.BUY:
      case ETransactionUiType.SELL:
      case ETransactionUiType.FX_TRANSACTION:
        sign = '';
        break;
      case ETransactionUiType.DEPOSIT:
      case ETransactionUiType.DIVIDEND:
      case ETransactionUiType.ROUNDING_RETURN:
      case ETransactionUiType.OPF_MANAGEMENT_FEE_REFUND:
        sign = '+';
        break;
      default:
        sign = this.transaction.amount > 0 ? '+' : '-'
        break;
    }
    return sign;
  }

  public transactionSelected(transactionId: string): void {
    this.optionSelected.emit(transactionId);
  }

}
